export interface CommerceStep {
  id: PreCatalogStepId | PostCatalogStepId | string
  longName: string
  shortName: string
  catalogFlowStepId: string | null
  routeUrl: string
  number: number | null
  displaysBundleIds: string[] | null
}

export enum PreCatalogStepId {
  GALLERY = 'gallery',
  YEARBOOK = 'yearbook'
}

export enum PostCatalogStepId {
  RETOUCHING = 'retouching',
  SELECT_POSES = 'select-poses',
  CHECKOUT = 'checkout'
}

/**
 * Id for the dedicated Package Builder step. Unlike the pre/post-catalog step
 * ids, this step is spliced into the *catalog* section of the flow (immediately
 * after the catalog flow step that offers SheetSelection bundles), so it
 * belongs to neither `PreCatalogStepId` nor `PostCatalogStepId`. It is a
 * standalone constant rather than an enum member to avoid implying it is part
 * of either configured step list on `mainStore.commerceSteps`.
 */
export const PACKAGE_BUILDER_STEP_ID = 'package-builder'
